var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3C5.8431 3 4.5 4.35 4.5 6V18V24V33C4.5 34.65 5.8431 36 7.5 36H28.5C30.1575 36 31.5 34.65 31.5 33V24V18V12L22.5 3H7.5Z",
    fill: "#95A5A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C5.8431 1.5 4.5 2.85 4.5 4.5V16.5V22.5V31.5C4.5 33.15 5.8431 34.5 7.5 34.5H28.5C30.1575 34.5 31.5 33.15 31.5 31.5V22.5V16.5V10.5L22.5 1.5H7.5Z",
    fill: "#BDC3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 10.5L22.5 1.5V7.5C22.5 9.15 23.8425 10.5 25.5 10.5H31.5Z",
    fill: "#95A5A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5C16.3425 19.5 15 20.85 15 22.5V28.5C15 30.15 16.3425 31.5 18 31.5C19.6575 31.5 21 30.15 21 28.5V22.5C21 20.85 19.6575 19.5 18 19.5ZM18 21C18.828 21 19.5 21.6 19.5 22.5C19.5 23.25 18.828 24 18 24C17.172 24 16.5 23.25 16.5 22.5C16.5 21.6 17.172 21 18 21ZM18 25.5C18.828 25.5 19.5 26.1 19.5 27V28.5C19.5 29.25 18.828 30 18 30C17.172 30 16.5 29.25 16.5 28.5V27C16.5 26.1 17.172 25.5 18 25.5Z",
    fill: "#BDC3C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5V16.5C15 18.15 16.3425 19.5 18 19.5C19.6575 19.5 21 18.15 21 16.5V1.5H15Z",
    fill: "#7F8C8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5V3H19.5V1.5H18ZM18 3H16.5V4.5H18V3ZM18 4.5V6H19.5V4.5H18ZM18 6H16.5V7.5H18V6ZM18 7.5V9H19.5V7.5H18ZM18 9H16.5V10.5H18V9ZM18 10.5V12H19.5V10.5H18ZM18 12H16.5V13.5H18V12ZM18 13.5V15H19.5V13.5H18ZM18 15H16.5V16.5H18V15ZM18 16.5V18C18.828 18 19.5 17.25 19.5 16.5H18Z",
    fill: "#95A5A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.5V3H18V1.5H16.5ZM16.5 4.5V6H18V4.5H16.5ZM16.5 7.5V9H18V7.5H16.5ZM16.5 10.5V12H18V10.5H16.5ZM16.5 13.5V15H18V13.5H16.5ZM16.5 16.5C16.5 17.25 17.172 18 18 18V16.5H16.5Z",
    fill: "#ECF0F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5C16.3425 19.5 15 20.85 15 22.5V28.5C15 30.15 16.3425 31.5 18 31.5C19.6575 31.5 21 30.15 21 28.5V22.5C21 20.85 19.6575 19.5 18 19.5ZM18 21C18.828 21 19.5 21.6 19.5 22.5C19.5 23.25 18.828 24 18 24C17.172 24 16.5 23.25 16.5 22.5C16.5 21.6 17.172 21 18 21ZM18 25.5C18.828 25.5 19.5 26.1 19.5 27V28.5C19.5 29.25 18.828 30 18 30C17.172 30 16.5 29.25 16.5 28.5V27C16.5 26.1 17.172 25.5 18 25.5Z",
    fill: "#95A5A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18C16.3425 18 15 19.35 15 21V27C15 28.65 16.3425 30 18 30C19.6575 30 21 28.65 21 27V21C21 19.35 19.6575 18 18 18ZM18 19.5C18.828 19.5 19.5 20.1 19.5 21C19.5 21.75 18.828 22.5 18 22.5C17.172 22.5 16.5 21.75 16.5 21C16.5 20.1 17.172 19.5 18 19.5ZM18 24C18.828 24 19.5 24.6 19.5 25.5V27C19.5 27.75 18.828 28.5 18 28.5C17.172 28.5 16.5 27.75 16.5 27V25.5C16.5 24.6 17.172 24 18 24Z",
    fill: "#ECF0F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/_zip.33d5abe6b6955a785430094951390517.svg";
export { ForwardRef as ReactComponent };